export enum IssueSeverityCssClassEnum {
  ERROR = 'has-error',
  WARNING = 'has-warning',
  INFO = 'has-advice'
}
